"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.configure = void 0;

var _services = require("./services");

var _instance = require("./instance");

var i18n = (0, _instance.instance)();

var configure = function configure(options) {
  var _options$plugins = options.plugins,
      plugins = _options$plugins === void 0 ? [] : _options$plugins,
      locale = options.locale,
      defaultValues = options.defaultValues;
  (0, _services.extend)(plugins, options, i18n);
  if (locale) i18n.setLocale(locale);
  if (defaultValues) i18n.setDefaultValues(defaultValues);
  return i18n;
};

exports.configure = configure;
var _default = i18n;
exports["default"] = _default;